var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('div',{staticClass:"g-recaptcha",class:{'is-invalid': _vm.invalid},attrs:{"id":_vm.id}}),_c('local-errors',{attrs:{"value":_vm.errors}}),(_vm.help)?_c('div',{staticClass:"form-text"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }